// extracted by mini-css-extract-plugin
export default {"cls1":"Id16IYHTwCw3gaIQvdDK","cls2":"j1uyNQiSNKDKN02TjmQ7 Id16IYHTwCw3gaIQvdDK","isPhone":"QONCIFm8olaf3QoworvV"};